import { Injectable } from '@angular/core';
import {
  Router,
  CanActivate,
  CanActivateChild,
  ActivatedRouteSnapshot,
  NavigationExtras,
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, filter } from 'rxjs/operators';
import { AppStateFacade } from '../+state/app-state.facade';
import { CommonService } from '@biz2x/libraries/core-utils/utils';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate, CanActivateChild {
  tokenFromLocalStorage = localStorage.getItem('token');
  adminToken = this.common.getDataFromStorage('admin_token', localStorage);

  constructor(
    private appFacade: AppStateFacade,
    private router: Router,
    private common: CommonService
  ) {}

  canActivate(next: ActivatedRouteSnapshot): Observable<boolean> {
    const queryParams = next.queryParams;
    const isFromCMPortal = next.queryParams['isFromCMPortal'];
    const mode = next.queryParams['mode'];
    if (isFromCMPortal) {
      console.log(localStorage.length);
      if(localStorage.length > 0) {
        localStorage.clear();
        console.log("LocalStorage was cleared.");
      }
      const navigationExtras = {
        replaceUrl: true,
        queryParams: {},
      };
      const navigateTo = next.routeConfig.children[0].path || '';
      this.router.navigate([navigateTo], navigationExtras);
      const { token, user, caseId, cmData, affiliate_referenceId } =
        JSON.parse(atob(queryParams['token'])) || {};
      localStorage.setItem('token', JSON.stringify(token));
      localStorage.setItem('user', JSON.stringify(user));
      localStorage.setItem('mode', mode);
      if (mode == 'EDIT' ) {
        localStorage.setItem('caseId', JSON.stringify(caseId));
      } else if( mode == 'COPY'){
        localStorage.setItem('caseId', JSON.stringify(caseId));
        localStorage.setItem('affiliate_referenceId', affiliate_referenceId);
      } 
      else {
        localStorage.removeItem('caseId');
      }
      // localStorage.setItem('caseId', JSON.stringify(caseId));
      // localStorage.setItem('new_caseId', JSON.stringify(new_caseId));
      localStorage.setItem('CMUserData', JSON.stringify(cmData));
      localStorage.setItem('route', 'v3');
      this.tokenFromLocalStorage = localStorage.getItem('token');
    }

    if (this.adminToken) {
      return of(true);
    } else {
      return this.appFacade.accessToken$.pipe(
        filter((token) => token !== undefined),
        map((token) => {
          if (!token) {
            this.router.navigateByUrl('/login');
            return false;
          }

          return true;
        })
      );
    }
  }

  canActivateChild(next: ActivatedRouteSnapshot) {
    return this.canActivate(next);
  }
}
